import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leaflet-contact-broker-agent',
  templateUrl: './leaflet-contact-broker-agent.component.html',
  styleUrls: ['./leaflet-contact-broker-agent.component.scss']
})
export class LeafletContactBrokerAgentComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<LeafletContactBrokerAgentComponent>
  ) { }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
